import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const SecurityPage = lazy(() => import("./SecurityPage"));

const SecurityPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <SecurityPage />
    </Suspense>
  );
};

export default SecurityPageLazy;
